import { createContext } from 'react';

type SplashContextType = {
  addLoader: () => void;
  removeLoader: () => void;
};

const SplashContext = createContext<SplashContextType>({
  addLoader: () => {},
  removeLoader: () => {},
});
export default SplashContext;
